import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      light: {
        primary: '#CF205A',
        error: '#d50000',
        info: '#29b6f6',
        success: '#64dd17',
        warning: '#fdd835'
      },
      dark: {
        primary: '#CF205A'
      }
    }
  }
})
